import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/analytics"
import { firebaseConfig } from './config';

firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({
});
// firebase.auth().onAuthStateChanged(async user => {
//     console.log("authStateChanged", user);
//     if (!user) {
//         await firebase.auth().signInAnonymously();
//     }
// });

export default firebase;
